import React from 'react';
import { FilterDropdown } from '@components/common/FilterDropdown';
import { Checkbox } from '@fourthwall/components';
import { useFormik } from '@fourthwall/utils/dist/formik';
import { useFilterContributions } from '../../hooks/useFilterContributions';
import * as S from './OrdersFilter.styled';
import { ORDER_TYPE_MAP, SALES_CHANNEL_MAP, STATUS_MAP } from './consts';
import { mapEntriesToOptions } from './utils/mapEntriesToOptions';
export const OrdersFilter = () => {
    const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } = useFilterContributions();
    const initialValues = {
        status: filtersParams.status ? filtersParams.status.split(',') : [],
        salesChannel: filtersParams.salesChannel ? filtersParams.salesChannel.split(',') : [],
        type: filtersParams.type ? filtersParams.type.split(',') : [],
    };
    const handleSubmit = (values) => {
        setFiltersParams({
            status: values.status.length ? values.status.join(',') : undefined,
            salesChannel: values.salesChannel.length ? values.salesChannel.join(',') : undefined,
            type: values.type.length ? values.type.join(',') : undefined,
        });
    };
    const formik = useFormik({
        initialValues,
        onSubmit: handleSubmit,
    });
    const statuses = Object.entries(STATUS_MAP).map(mapEntriesToOptions);
    const salesChannels = Object.entries(SALES_CHANNEL_MAP).map(mapEntriesToOptions);
    const types = Object.entries(ORDER_TYPE_MAP).map(mapEntriesToOptions);
    const handleReset = () => {
        formik.resetForm();
        resetFiltersParams();
    };
    const handleCheckboxGroupChange = (checked, value, name) => {
        const fieldValue = checked
            ? [...formik.values[name], value]
            : formik.values[name].filter((v) => v !== value);
        formik.setFieldValue(name, fieldValue);
    };
    return (React.createElement(FilterDropdown, { content: React.createElement(S.Form, null,
            React.createElement(S.FiltersColumn, null,
                React.createElement("div", null,
                    React.createElement(FilterDropdown.GroupTitle, { title: "Status" }),
                    React.createElement(S.CheckboxGroup, { role: "group" }, statuses.map((status) => (React.createElement(Checkbox, { native: true, key: status.value, label: status.label, value: status.value, checked: formik.values.status.includes(status.value), onValueChange: (checked) => handleCheckboxGroupChange(checked, status.value, 'status') })))))),
            React.createElement(S.FiltersColumn, null,
                React.createElement("div", null,
                    React.createElement(FilterDropdown.GroupTitle, { title: "Sales channel" }),
                    React.createElement(S.CheckboxGroup, { role: "group" }, salesChannels.map((salesChannel) => (React.createElement(Checkbox, { native: true, key: salesChannel.value, label: salesChannel.label, value: salesChannel.value, checked: formik.values.salesChannel.includes(salesChannel.value), onValueChange: (checked) => handleCheckboxGroupChange(checked, salesChannel.value, 'salesChannel') }))))),
                React.createElement("div", null,
                    React.createElement(FilterDropdown.GroupTitle, { title: "Sample orders" }),
                    React.createElement(S.CheckboxGroup, { role: "group" }, types.map((type) => (React.createElement(Checkbox, { native: true, key: type.value, label: type.label, value: type.value, checked: formik.values.type.includes(type.value), onValueChange: (checked) => handleCheckboxGroupChange(checked, type.value, 'type') }))))))), activityIndicator: hasFilterParams, onSubmit: formik.handleSubmit, onReset: handleReset }));
};
